export function getVirginiaApiRestEndpoint() {
  return getApiRestEndpoint("us-east-1");
}

export function getApiRestEndpoint(region) {
  return process.env.VUE_APP_DEXTR_MORGAN_APIG_URL.replace("{region}", region);
}
